module.exports = __webpack_public_path__ + "static/img/seckill_sm_btn_disabled.d57fd294.png";